import { Icons } from "@app/shared";
import cn from "classnames";
import React, { PropsWithChildren } from 'react';

type MediaSelectorItemProps = {
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    title?: React.ReactElement | React.ReactNode | string;
    selected?: boolean;
    imageUrl?: string;
    listFormat?: boolean;
}
const isImage = (url: string) =>
    url.toLowerCase().endsWith("jpg") ||
    url.toLowerCase().endsWith("jpeg") ||
    url.toLowerCase().endsWith("bmp") ||
    url.toLowerCase().endsWith("png") ||
    url.toLowerCase().endsWith("gif");

const isVideo = (url: string) =>
    url.toLowerCase().endsWith("mp4") ||
    url.toLowerCase().endsWith("avi") ||
    url.toLowerCase().endsWith("mov") ||
    url.toLowerCase().endsWith("mkv");

const isJson = (url: string) =>
    url.toLowerCase().endsWith("json");

const isBinaryFile = (url: string) =>
    url.toLowerCase().endsWith("radar") ||
    url.toLowerCase().endsWith("bin");

export const MediaSelectorItem: React.FC<PropsWithChildren<MediaSelectorItemProps>> = ({ imageUrl, selected, children, title, listFormat = true, ...props }) => {
    const iconSize = listFormat ? 24 : 64;



    return (
        <div className={cn("flex", { "flex-col": !listFormat })}>
            <div className={
                cn(
                    { "w-52 h-40 flex place-content-center place-items-center": !listFormat },
                    { "cursor-pointer ": props.onClick },
                    (selected ? "border-link-page border-2" : "border-separators-page border"))
            } {...props}>
                <div className="flex flex-col place-content-center place-items-center gap-2">
                    {imageUrl && isImage(imageUrl) &&
                        <img draggable="false" onDragStart={() => false} src={imageUrl} alt="" />
                    }
                    {imageUrl && isVideo(imageUrl) &&
                        <>
                            <Icons.VideoFile size={iconSize} />
                            {!listFormat && <div>No Preview</div>}
                        </>
                    }
                    {imageUrl && isJson(imageUrl) &&
                        <>
                            <Icons.JsonFile size={iconSize} />
                            {!listFormat && <div>No Preview</div>}

                        </>
                    }
                    {imageUrl && isBinaryFile(imageUrl) &&
                        <>
                            <Icons.BinaryFile size={iconSize} />
                            {!listFormat && <div>No Preview</div>}

                        </>
                    }
                </div>
                {children}
            </div>
            <div>
                {title}
            </div>
        </div >
    );
}
